// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cKNk","title":"styles_title__1YsCc"};